import React from 'react';

const Terms = () => (
  <section className="page">
    <h1>Terms of Service</h1>

    <h2>Using Hestia Ledger</h2>
    <p>
      Hestia Ledger’s an app I built—Blueprint Byte—to help you track your finances, personal or small 
      business. The free version’s yours to try at app.hestialedger.com, no cost, no catch. The full 
      version’s got more features (cloud storage, exports, etc.)—details on the Services page. Use it 
      however you want, but don’t break laws or screw anyone over with it. Cool?
    </p>

    <h2>Data & Responsibility</h2>
    <p>
      Your data’s stored in MongoDB—password’s encrypted, the rest isn’t (check the Privacy Policy). I 
      don’t touch it, don’t sell it, but I’m not a security guru either. If something goes wrong—hacks, 
      glitches, whatever—I’m not liable. You’re using this at your own risk. Back up your stuff, and 
      don’t put anything in here you can’t afford to lose.
    </p>

    <h2>No Warranties, No Promises</h2>
<p>
  This app’s “as-is”—no fancy guarantees. I’m a guy with a keyboard, not a corporation with a 
  warranty department. It might break, it might not do what you expect—sorry in advance. No refunds 
  on the full version yet (since it’s not priced here), but if that changes, I’ll update this. 
  Questions? Hit <a href="mailto:bell@hestialedger.com">bell@hestialedger.com</a>.
</p>

    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Terms;